import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { ProfileType } from '@cigna/cigna-for-brokers/shared/data-access';
@Component({
  selector: 'cigna-training-education',
  templateUrl: './training-education.component.html',
  styleUrls: ['./training-education.component.scss'],
})
export class TrainingEducationComponent implements OnInit, AfterViewInit {
  isOnDemandTrainingEducationToggleOn: boolean;
  isOnDemandTrainingEducationEnabled$ =
    this.featureTogglesFacade.featuresEnabled([
      'isOnDemandTrainingEducationEnabled',
    ]);
  isImpersonatorFlag: boolean;
  profileData$ = this._appstateFacade.isProfileUser$;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  accessToken: string | undefined;
  operatorId: unknown;
  isImpersonatorEnabled: boolean;
  isImpersonatorEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isImpersonatorEnabled',
  ]);

  constructor(
    private featureTogglesFacade: FeatureTogglesFacade,
    private analytics: ShellTrackHandlers,
    public _appstateFacade: AppstateFacade,
  ) {}

  ngOnInit(): void {
    this.isOnDemandTrainingEducationEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOnDemandTrainingEducationEnabled) => {
        this.isOnDemandTrainingEducationToggleOn =
          isOnDemandTrainingEducationEnabled;
      });

    this.isImpersonatorEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isImpEnabled) => {
        this.isImpersonatorEnabled = isImpEnabled;
      });

    this.profileData$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: ProfileType) => {
        if (res) {
          this.accessToken = res.accessToken;

          this.operatorId = res.accessTokenBody['agent.operatorId'];
          if (
            this.operatorId &&
            this.operatorId !== '' &&
            this.isImpersonatorEnabled
          ) {
            this.isImpersonatorFlag = true;
          }
        }
      });
  }
  ngAfterViewInit(): void {
    if (!this.isImpersonatorFlag) {
      this._appstateFacade.sendAnalytics({
        event: 'pageLoad',
        reqData: {
          requirementId: 'pv25029',
          userStory: 'MTD-1662',
          hitType: 'page view',
        },
        pageData: {
          siteSection: 'Learning Center',
          URL: window.location.href,
          pageName: 'Producer Learning Center',
        },
      });
    }
  }
}
